import { useEffect, useState } from "react";
import UserTag from "../../../models/userTag";
import AddRemoveTagsAction from "./AddRemoveTagsAction";
import AddRemoveTagsData from "./AddRemoveTagsData";

const AddRemoveTags: React.FC<{
  userTags: UserTag[];
  selectedUserCount: number;
  onAddRemoveTagsChanged: any;
}> = ({ userTags: allUserTags, selectedUserCount, onAddRemoveTagsChanged }) => {
  const [userTags, setUserTags] = useState<UserTag[]>([]);
  const [selectedCount, setSelectedCount] = useState<number>(0);

  const [searchText, setSearchText] = useState<string>("");

  const [selectedAction, setSelectedAction] = useState<AddRemoveTagsAction>(
    AddRemoveTagsAction.AddTags
  );

  useEffect(() => {
    for (const userTag of allUserTags) {
      userTag.isSelected = false;
    }

    const userTags = [...allUserTags];
    setUserTags(userTags);
  }, [allUserTags]);

  useEffect(() => {
    const clearSelected = () => {
      setSelectedCount(0);

      for (const userTag of allUserTags) {
        userTag.isSelected = false;
      }

      onAddRemoveTagsChanged(new AddRemoveTagsData());
    };

    clearSelected();

    const searchToken = searchText.toLowerCase();

    let filteredUserTags = allUserTags.filter((ut) =>
      ut.tagName.toLowerCase().includes(searchToken)
    );

    setUserTags(filteredUserTags);
  }, [allUserTags, searchText, onAddRemoveTagsChanged]);

  useEffect(() => {
    let selectedCount = 0;

    for (const userTag of userTags) {
      if (userTag.isSelected) {
        selectedCount++;
      }
    }

    setSelectedCount(selectedCount);

    const addRemoveTagsData = new AddRemoveTagsData();
    addRemoveTagsData.tagAction = selectedAction;
    addRemoveTagsData.userTags = userTags.filter((ut) => ut.isSelected);
    onAddRemoveTagsChanged(addRemoveTagsData);
  }, [userTags, selectedAction, onAddRemoveTagsChanged]);

  const onSelectUserTagChanged = (event: any, userTag: UserTag) => {
    const checked = event.target.checked;
    userTag.isSelected = checked;

    const updatedUserTags = [...userTags];
    setUserTags(updatedUserTags);
  };

  const onRowClick = (event: any, userTag: UserTag) => {
    userTag.isSelected = !userTag.isSelected;

    const updatedUserTags = [...userTags];
    setUserTags(updatedUserTags);
  };

  const onSearchTextChange = (event: any) => {
    const value = event.target.value.toLowerCase();
    setSearchText(value);
  };

  const onActionChanged = async (event: any) => {
    const newValue = event.target.value;
    setSelectedAction(newValue);
  };

  return (
    <div>
      <div className="mb-3">
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={searchText}
            onChange={onSearchTextChange}
          />
          <button type="submit" className="btn btn-primary">
            Search
          </button>
        </div>
      </div>

      <div style={{ maxHeight: "400px", overflowY: "scroll" }} className="mb-3">
        <table className="table table-borderless table-hover">
          <tbody>
            {userTags.map((userTag: UserTag, index) => (
              <tr
                key={index.toString()}
                onClick={(event: any) => onRowClick(event, userTag)}
              >
                <td style={{ width: "10px" }}>
                  <input
                    className="form-check-input form-switch-right-text"
                    type="checkbox"
                    checked={userTag.isSelected ?? false}
                    onChange={(event) => onSelectUserTagChanged(event, userTag)}
                  />
                </td>
                <td>
                  <span className="user-tag">{userTag.tagName}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mb-3">
        <div className="mb-3">
          <b>Choose Action</b>
        </div>
        <select
          className="form-select"
          aria-label="select"
          id="dateRangeSelect"
          value={selectedAction}
          onChange={onActionChanged}
        >
          <option value={AddRemoveTagsAction.AddTags}>Add Tags</option>
          <option value={AddRemoveTagsAction.RemoveTags}>Remove Tags</option>
        </select>
      </div>

      <div>
        {selectedAction === AddRemoveTagsAction.AddTags && (
          <span>{`${selectedCount} tags will be added to ${selectedUserCount} selected ${
            selectedUserCount > 1 ? "users" : "user"
          }.`}</span>
        )}
        {selectedAction === AddRemoveTagsAction.RemoveTags && (
          <span>{`${selectedCount} tags will be removed from ${selectedUserCount} selected ${
            selectedUserCount > 1 ? "users" : "user"
          }.`}</span>
        )}
      </div>
    </div>
  );
};

export default AddRemoveTags;
